module.exports = __webpack_public_path__ + "img/IMG_3300.fd1bcf1d.jpg";